(function() {
  function clearLinkedData() {
    var linkedDataScripts = Array.from(document.head.querySelectorAll('script[type="application/ld+json"]'));
    linkedDataScripts.forEach(function(script) {
      document.head.removeChild(script);
    });
  }

  document.addEventListener('turbolinks:before-visit', clearLinkedData);
})();